'use strict';

import $ from 'jquery';
import { initTooltips } from '@/js/modules/tooltips';
import confirmDialog from '@/js/modules/confirm_dialog';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if (['board', 'boards-preview', 'board-preview'].includes(document.body.id)) {
      // check if all items are approved
      const checkApproved = function () {
        $('.shoppable__approvement-container').each(function () {
          if (!$(this).find('.js-radio__pending').is(':checked')) {
            $(this).addClass('state-selected');
          }
        });
      };

      checkApproved();

      // board_show_v2 shifts the bubble left by however much it would overflow the window, keeping a 16px gutter
      // (designer_view_v2.scss); the legacy view ignores the shift.
      const showFeedback = function ($feedback) {
        const feedback = $feedback[0];
        feedback.style.setProperty('--shoppable-feedback-shift', '0px');
        $feedback.fadeIn(200);
        const overflow =
          feedback.getBoundingClientRect().right + 16 - document.documentElement.clientWidth;
        feedback.style.setProperty('--shoppable-feedback-shift', `${Math.max(overflow, 0)}px`);
        return $feedback;
      };

      // set state
      $(document).on('change', '.js-shoppable__radio', function () {
        const $shoppable = $(this).closest('.shoppable');
        const $stateIcon = $shoppable.find('.shoppable__state-icon');
        const state = $(this).val();
        const boardShoppableId = $shoppable.data().boardShoppableId;
        const kind = $shoppable.data().kind;
        const url = `/board_shoppables/${kind}/${boardShoppableId}/xhr_toggle_approval`;

        checkApproved();

        $.post(url, { state }).done(() => {
          document.dispatchEvent(new CustomEvent('boards:shoppables-changed'));
        });

        $('.shoppable__feedback').fadeOut(200);
        // decline item
        if (state === 'declined') {
          $stateIcon
            .removeClass('shoppable__state-icon--approved')
            .addClass('shoppable__state-icon--declined');
          $stateIcon.find('.tooltip__content').text(`Your client has ${state} this item`);
          showFeedback($shoppable.find('.shoppable__feedback')).find('textarea').focus();
          // approve item
        } else if (state === 'approved') {
          // $shoppable.find('.shoppable__feedback-submit-controls').addClass('hide');
          $shoppable.find('.shoppable__feedback-controls').addClass('hide');
          $shoppable.find('.shoppable__feedback-text').text('');
          $shoppable.find('.shoppable__decline-comment').remove();
          $shoppable.find('.shoppable__feedback').fadeOut(200, function () {
            $shoppable.find('.js-feedback-form').removeClass('hide');
            $shoppable.find('.shoppable__feedback-textarea').val('');
          });

          $stateIcon
            .removeClass('shoppable__state-icon--declined')
            .addClass('shoppable__state-icon--approved');
          $stateIcon.find('.tooltip__content').text(`Your client has ${state} this item`);
          // pending item
        } else if (state === 'pending') {
          // $shoppable.find('.shoppable__feedback-submit-controls').addClass('hide');
          $shoppable.find('.shoppable__feedback-controls').addClass('hide');
          $shoppable.find('.shoppable__feedback-text').text('');
          $shoppable.find('.shoppable__decline-comment').remove();
          $shoppable.find('.shoppable__feedback').fadeOut(200, function () {
            $shoppable.find('.js-feedback-form').removeClass('hide');
            $shoppable.find('.shoppable__feedback-textarea').val('');
          });

          $shoppable.find('.state-selected').removeClass('state-selected');
          $stateIcon.removeClass('shoppable__state-icon--approved shoppable__state-icon--declined');
        }
        initTooltips($stateIcon);
      });

      // set item to pending if clicked on selected state
      $(document).on(
        'click',
        '.h-p-button--shoppable-approve, .h-p-button--shoppable-decline',
        (e) => {
          // The label, not e.target: a click on its icon targets the icon.
          const $label = $(e.currentTarget);
          const feedbackPopup = $label
            .closest('.shoppable__decline-container')
            .find('.shoppable__feedback');
          if ($('#' + $label.attr('for')).is(':checked')) {
            if (
              window.innerWidth < 990 &&
              feedbackPopup.is(':hidden') &&
              $label.hasClass('h-p-button--shoppable-decline')
            ) {
              showFeedback(feedbackPopup);
              return false;
            }
            $label
              .closest('.shoppable__approvement-container')
              .find('.js-radio__pending')
              .prop('checked', true)
              .change();

            return false;
          }
        }
      );

      // show edit feedback on mouseenter
      if (window.innerWidth >= 990) {
        $(document).on(
          'mouseenter',
          '.h-p-button--shoppable-decline, .shoppable__decline-comment',
          function () {
            const $shoppable = $(this).closest('.shoppable');
            $('.shoppable').not($shoppable).find('.shoppable__feedback').addClass('hide');
            if ($shoppable.find('.js-shoppable__radio:checked').val() === 'declined') {
              showFeedback($shoppable.find('.shoppable__feedback')).find('textarea').focus();
            }
          }
        );
      }

      // skip feedback
      $(document).on('click', '.js-shoppable__feedback-skip', function () {
        const $shoppable = $(this).closest('.shoppable');
        const boardShoppableId = $shoppable.data().boardShoppableId;
        const kind = $shoppable.data().kind;
        const url = `/board_shoppables/${kind}/${boardShoppableId}/xhr_set_declined_message`;

        $.post(url, { declined_message: '' });

        $(this)
          .closest('.shoppable__feedback')
          .fadeOut(200)
          .find('.shoppable__feedback-textarea')
          .val('');
        return false;
      });

      // hide feedback when clicked elsewhere
      $('html').click(function (e) {
        const $target = $(e.target);
        if ($($target).closest('.shoppable__feedback').length || $target.is('.radio__declined')) {
        } else {
          $('.shoppable__feedback').fadeOut(200);
        }
      });

      // add feedback for declined item
      $(document).on('submit', '.js-feedback-form', function () {
        const $shoppable = $(this).closest('.shoppable');
        const feedback = $(this).find('.shoppable__feedback-textarea').val();

        const boardShoppableId = $shoppable.data().boardShoppableId;
        const kind = $shoppable.data().kind;
        const url = `/board_shoppables/${kind}/${boardShoppableId}/xhr_set_declined_message`;

        $.post(url, { declined_message: feedback });

        $shoppable.find('.shoppable__feedback').fadeOut(200, function () {
          $shoppable.find('.js-feedback-form').addClass('hide');
          $shoppable.find('.shoppable__feedback-controls').removeClass('hide');
          $shoppable.find('.shoppable__feedback-text').text(feedback);
        });
        $shoppable
          .find('.shoppable__state-icon--declined')
          .append($('<div class="shoppable__decline-comment">1</div>').hide().fadeIn(200));

        return false;
      });

      // edit rejection feedback
      $(document).on('click', '.js-shoppable__feedback-edit', function () {
        const $item = $(this).closest('.shoppable');
        $item.find('.shoppable__feedback-controls').addClass('hide');
        $item.find('.js-feedback-form').removeClass('hide');
        $item.find('.shoppable__feedback-textarea').focus();
        return false;
      });

      // remove rejectioin feedback
      $(document).on('click', '.js-shoppable__feedback-controls-delete', async function (e) {
        e.preventDefault();

        if (!(await confirmDialog('Delete this feedback?', { button: 'Delete' }))) {
          return;
        }

        const $shoppable = $(this).closest('.shoppable');

        const boardShoppableId = $shoppable.data().boardShoppableId;
        const kind = $shoppable.data().kind;
        const url = `/board_shoppables/${kind}/${boardShoppableId}/xhr_set_declined_message`;

        $.post(url, { declined_message: '' });

        $shoppable.find('.shoppable__feedback-controls').addClass('hide');
        $shoppable.find('.shoppable__feedback-text').text('');
        $shoppable.find('.shoppable__decline-comment').remove();
        $shoppable.find('.shoppable__feedback').fadeOut(200, function () {
          $shoppable.find('.js-feedback-form').removeClass('hide');
          $shoppable.find('.shoppable__feedback-textarea').val('');
        });
      });

      $(document).on('click', '.shoppable__decline-feedback-close', function () {
        const $shoppable = $(this).closest('.shoppable');
        $shoppable.find('.shoppable__feedback').hide();

        return false;
      });
    }
    // TODO: Robert refactor
    if ($('body').is('#board')) {
      function updateQuantity($shoppable, qty) {
        const $qtyField = $shoppable.find('.qty-controls__qty');
        const boardShoppableId = $shoppable.data().boardShoppableId;
        const kind = $shoppable.data().kind;
        const url = `/board_shoppables/${kind}/${boardShoppableId}/xhr_change_qty`;

        if (!$qtyField.val().length || parseFloat($qtyField.val()) <= 0) {
          $qtyField.val('1');
        }

        $.post(url, { qty }, (data) => {
          const $boardCostField = $('.board-products__total-board-cost');
          const $decreaseLink = $shoppable.find('.qty-controls__link--decrease');

          $qtyField.val(data.qty);
          $boardCostField.text(data.cost);
          $decreaseLink.toggleClass('qty-controls__link--disabled', data.qty < 2);
          document.dispatchEvent(new CustomEvent('boards:shoppables-changed'));
        });
      }

      $(document).on('click', '.qty-controls__link', (e) => {
        const $link = $(e.target);
        const $shoppable = $link.closest('.shoppable');
        const $qtyField = $shoppable.find('.qty-controls__qty');

        let qty = parseInt($qtyField.val());
        if ($link.hasClass('qty-controls__link--decrease')) {
          qty = qty - 1;
        } else if ($link.hasClass('qty-controls__link--increase')) {
          qty = qty + 1;
        }

        if (
          $link.hasClass('qty-controls__link--increase') ||
          $link.hasClass('qty-controls__link--decrease')
        ) {
          updateQuantity($shoppable, qty);
        } else {
          $qtyField.val(qty).trigger('blur');
        }

        return false;
      });

      $(document).on('focus', '.qty-controls__qty', (e) => {
        $(e.target).select();
      });

      $(document).on('keypress', '.qty-controls__qty', (e) => {
        if (e.keyCode === 13) {
          $(e.target).trigger('blur');
        } else {
          const t = $(e.target).val();
          $(e.target).val(
            t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 2) : t
          );
        }
      });

      $(document).on('blur', '.qty-controls__qty', (e) => {
        const $qtyField = $(e.target);
        const $shoppable = $qtyField.closest('.shoppable');
        const qty = parseInt($qtyField.val());

        updateQuantity($shoppable, qty);

        return false;
      });
    }
  });
});
